export const externalPath = {
  onboard: 'https://onboarding.smebank.lt',
  smeBankPrivacyPolicy: 'https://smebank.lt/privatumo-politika/',
  smeBankPrivacyPolicyEn: 'https://smebank.lt/en/privacy-policy/',
  smeBankGeneralAgreements: 'https://smebank.lt/bendrosios-sutarciu-salygos/',
  smeBankGeneralAgreementsEn: 'https://smebank.lt/en/general-agreements/',
};
